import { filterObjectValues } from 'helpers/filter'

import { DivisionType } from 'models/common'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs/fileResponseHandler'

import api from '../api'
import { GetMBonusListResponse, GetMBonusParams, MBonusObject } from './types'

export const mbonusApi = api.injectEndpoints({
  endpoints: build => ({
    getMBonus: build.query<GetMBonusListResponse, GetMBonusParams>({
      query: params => ({
        url: `/web/mbonus/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    getMBonusCashback: build.query<string[], void>({
      query: () => ({
        url: `/web/mbonus/cashback/`,
      }),
    }),
    getMBonusFieldActivity: build.query<
      Array<{ id: number; name: string }>,
      void
    >({
      query: () => ({
        url: `/web/field_activity/`,
      }),
    }),
    getMBonusBranches: build.query<
      [
        {
          id: number
          name: string
          type_division: DivisionType
        },
      ],
      void
    >({
      query: () => ({
        url: `/web/combined_branches/`,
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    getMBonusById: build.query<MBonusObject, MBonusObject['id']>({
      query: id => ({
        url: `/web/mbonus/${id}/`,
      }),
    }),
    mbonusStatistics: build.query<Array<IStatistic>, GetMBonusParams>({
      query: params => ({
        url: `/web/mbonus/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadMBonusExcel: build.mutation<void, GetMBonusParams>({
      query: params => ({
        url: `/web/mbonus/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
